import _ from 'lodash'
import React from 'react'
import { User } from '../../userprofile/types/user'
import { SessionHandlers } from '../../graphql/client'

export type AuthContextType = {
  user: Maybe<User>
  logout: () => void
  // Absent outside AuthProviderAzure (e.g. the public publish route).
  session?: SessionHandlers
}

const authContext = React.createContext<AuthContextType>({
  user: null,
  logout: _.noop,
})

authContext.displayName = 'AuthContext'

export { authContext as AuthContext }
